const PageContentRow = ({ children }) => {
  return (
    <div className="container p-4">
      <div className="row d-flex flex-wrap">{children}</div>
    </div>
  );
};

export { PageContentRow };
